<!-- Unified Training Requests -->

<div class="container">
    <div class="card v4-card card-ui flex">
        <div class="row p-0">
            <div class="col-lg-10 col-md-10 col-sm-12 col-12">
                <div class="p-2 border-1 surface-border border-round w-15rem custom-bg-1 shaddow" pDroppable (onDrop)="drop()">
                    <h4 class="drop-ou-ui border-bottom-1"><i class="pi pi-exclamation-circle icn-size mx-2"></i>{{trainingRequest.topic}}</h4>
                    <div class="mx-3">
                        <label class="label-ui">{{"Consolidated" | translator }}</label>
                    <p>{{trainingRequest.description}}</p>
                    </div>
                    <h4 class="drop-ou-ui border-bottom-1"><i class="pi pi-verified icn-size mx-2"></i>{{"Schedule training sessions" | translator}}</h4>
                    <span class="list-none flex flex-column gap-2 p-0 m-0" *ngIf="selectedMonths">
                        <label class="label-ui mx-3">{{"Add an organizational unit" | translator}}</label>
                        <div *ngFor="let month of selectedMonths" class="d-flex align-items-center mx-3">
                        <div class="p-2 my-2 border-round shadow-1 li-selected-ui">
                            <i class="pi pi-calendar mx-2"></i>
                           &nbsp;{{month.name}} - {{month.year}}
                        </div>
                        <span (click)="deleteMonth(month)"><i class="pi pi-times close"></i></span>
                    </div>
                        <div class="d-flex mx-3">
                        <p-treeSelect class="w-md-20rem width-90" appendTo="body" containerStyleClass="w-100"
                            [(ngModel)]="orgUnit" [options]="selectedTreeData" [placeholder]='"Classification of entity services" | translator' [filter]="true"
                            [filterInputAutoFocus]="true">
                            <ng-template let-node pTemplate="default">
                                <div class="d-flex">
                                    <img *ngIf="checkisImg(node.data); else elseBlock" src="{{staticURL}}{{node.data}}"
                                        class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px;">
                                    <ng-template #elseBlock>
                                        <i class="{{node.data}} p-2" style="font-size: 1rem;"></i>
                                    </ng-template>
                                    <b class="text-nowrap">{{ node.label }}</b>
                                </div>
                            </ng-template>
                        </p-treeSelect>
                        <button type="submit" [disabled]="selectedMonths.length <= 0 || !orgUnit " (click)="assignOrgUnit()"
                            class="w-full v4-btn-every mx-2 py-2"><i class="pi pi-plus v4-ml-2"></i>{{'Add' | translator}}</button>
                        </div>
                        <p *ngIf="assignError" style="color:red">{{'Month Already Assigned to Ou' | translator}}</p>
                    </span>

                </div>
                <h4 class="drop-ou-ui border-bottom-1 mx-3"><i class="pi pi-calendar icn-size mx-2"></i>{{"Custom units" | translator }}</h4>
            <div class="scroll-height">
                <div *ngFor="let assignedOrg of assignedList" class="OU-card mx-3" pDroppable (onDrop)="drop2(assignedOrg)">
                    <div class="w-100 d-flex justify-content-between">
                        <span (click)="deleteAssignment(assignedOrg)" ><i class="pi pi-times close"></i></span>
                        <div class="d-flex">
                            <div class="">
                                <img class="ou-img" *ngIf="checkisImg(assignedOrg.ou.data); else elseBlock2" src="{{staticURL}}{{assignedOrg.ou.data}}"
                                    src="https://media.istockphoto.com/id/1401473312/photo/young-saudi-man-saddling-camel-for-trek-in-desert.webp?b=1&s=170667a&w=0&k=20&c=i82cVe3USRM39rtctV6IjA0gRawmdnPRi4svxoTaFhI="
                                    alt="loading...">
                                    <ng-template #elseBlock2>
                                        <i class="{{assignedOrg.ou.data}} p-10" style="font-size: 2rem;"></i>
                                    </ng-template>
                            </div>
                            <div class="">
                                <p class="ou-head">{{assignedOrg.ou.label}}</p>
                                <p class="ou-text"><i class="pi pi-tag ml-ou-2"></i>{{trainingRequest.topic}}</p>
                            </div>
                        </div>
                        <div *ngIf="assignedOrg.date; else notassigned" class="d-flex justify-content-end column-reverse">
                            <span  class="year-ui pos-rel">
                                <span (click)="deleteMonth(assignedOrg.date, assignedOrg )"><i class="pi pi-times close pos-abs"></i></span>
                                <span>{{assignedOrg.date.month}}</span>
                            </span>
                            <span class="ou-head">{{assignedOrg.date.year}}</span> 
                        </div>
                        <ng-template #notassigned>
                            <span  class="">
                                <span><i class="pi pi-question"></i> {{"Not selected" | translator}}</span>
                             
                            </span>
                          </ng-template>
                    </div>
                    <hr class="w-100 my-1">
                </div>
            </div>

            </div>
            <div class="col-lg-2 col-md-2 col-sm-12 col-12">
                <div class="p-2 border-1 surface-border border-round w-15rem">
                    <ul class="list-none flex flex-column gap-2 p-0 m-0 pos-rel">
                    <h4 class="drop-ou-ui mt-2 mb-2"><i class="pi pi-calendar icn-size mx-2"></i>{{"Select the year" | translator}}</h4>
                            <label class="label-ui">({{"Add months" | translator }})</label>
                            <span (click)="generateMonths()" ><i class="pi pi-plus open"></i></span>
                        <li *ngFor="let month of availableMonths" class="p-2 border-round shadow-1 li-ui shaddow" pDraggable
                            (onDragStart)="dragStart(month)" (onDragEnd)="dragEnd()">
                           
                            {{month.name}} - {{month.year}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <button  type="button" (click)="sendRequest()" class="w-100 m-2 my-2 v4-btn-every py-2"><i class="pi pi-angle-double-left v4-ml-2"></i>{{"send" | translator}}</button>
            </div>
        </div>
    </div>
</div>